import React, { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import '../../components/shared/StatusBanner.css';
import './LiveChatWidget.css';

const LiveChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [closing, setClosing] = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: 'Hi there! How can I help you today?' },
  ]);
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);
  const sessionId = useRef(`sess-${Date.now()}`).current;

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const toggleChat = () => {
    setIsOpen(prev => !prev);
    setClosing(false);
  };

  const handleSend = async () => {
    if (!input.trim()) return;

    const newMessage = {
      from: 'user',
      text: input,
      sessionId,
    };
    setMessages(prev => [...prev, newMessage]);
    setInput('');

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newMessage),
      });

      if (!res.ok) throw new Error('Failed to send');

      setMessages(prev => [
        ...prev,
        { from: 'bot', text: "Thanks! We'll get back to you shortly." },
      ]);

      console.log('✅ Message logged to backend');

    } catch (err) {
      setMessages(prev => [
        ...prev,
        { from: 'bot', text: "⚠️ Oops! Couldn't reach support. Please try again later." },
      ]);
      console.error('❌ Error sending message:', err);
      toast.error('❌ Failed to send chat message.');
    }
  };

  const handleEndChat = () => {
    setClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setMessages([
        { from: 'bot', text: 'Hi there! How can I help you today?' },
      ]);
      setClosing(false);
    }, 300);
  };

  return (
    <div className="chat-widget">
      <button className="chat-toggle" onClick={toggleChat} aria-label="Open Live Chat">
        💬 Chat
      </button>

      {isOpen && (
        <div className={`livechat-panel ${closing ? 'closing' : ''}`}>
          <div className="livechat-panel-header">
            Live Support
            <button
              onClick={handleEndChat}
              aria-label="Close chat"
              style={{ background: 'none', border: 'none', color: 'white', float: 'right' }}
            >
              ✖
            </button>
          </div>

          <div className="livechat-panel-body">
            {messages.map((msg, i) => (
              <div key={i} className={`chat-message ${msg.from}`}>
                {msg.text}
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <div className="chat-input">
            <input
              type="text"
              placeholder="Type your message…"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              aria-label="Chat message input"
            />
            <button onClick={handleSend} aria-label="Send message">Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LiveChatWidget;
